const SETDETAIL = 'SET_DETAIL'
const SETCONFIG = 'SET_CONFIG'

export { SETDETAIL, SETCONFIG }
